// import Error from 'components/alerts/Error';
import { Info } from 'components/common/form/modules/Info';
import { Input, Label } from 'reactstrap'

import { NumberInput } from 'components/common/form/modules/input/Number';
import { Text } from 'components/common/form/modules/input/Text';
import { TextArea } from 'components/common/form/modules/input/TextArea';
import { TimezoneSelect } from "components/common/form/modules/input/TimezoneSelect";
import ImageUpload from 'components/upload/ImageUpload';

import React, { useCallback, useEffect, useState } from 'react'
import DatePicker from 'react-datepicker';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { CloseCircleOutline } from 'react-ionicons'
import { connect } from 'react-redux';
import UserDucks from 'stores/ducks/User.duck';

import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { isSubdomainAvailable, updateCampaign } from 'components/graphql/queries'
import { closeModal } from 'components/modal/modules/dispatcher/methods';


// import Slider from '@material-ui/core/Slider';
import { ResponsiveScatterPlot } from '@nivo/scatterplot'

const CampaignSettingsModal: React.FC<{ [label: string]: any }> = (props: any) => {

    if (props.user.id === '') {
        return null;
    }

    const today = new Date()
    const now = new Date()
    const zero = new Date()

    now.setHours(23)
    now.setMinutes(45)
    zero.setHours(0);
    zero.setMinutes(0);

    let flag1 = false;
    let flag2 = false;

    const [campaignId] = useState(props.campaignId)
    const [name, setName] = useState(props.name)
    const [cover] = useState(props.media.cover)
    const [fpBackground, setFpBackground] = useState(props.media.logo)
    const [description, setDescription] = useState(props.description)
    const [subdomain, setSubdomain] = useState(props.subdomain)
    const [showLeaderboard] = useState(props.showLeaderboard)
    const [allowAffiliates] = useState(props.maxLevels === null ? true : false)
    const [surveyQuestion, setSurveyQuestion] = useState(props.surveyQuestion ? props.surveyQuestion : '')
    const [location, setLocation] = useState<any>(props.location ? JSON.parse(props.location) : null)
    const [secretLocation, setSecretLocation] = useState(props.location ? props.secretLocation : false)
    const [btnDisabled, setBtnDisabled] = React.useState(false)
    const [saveBtnText, setSaveBtnText] = React.useState('SAVE')
    // const [error, setError] = useState(false)
    // const [errorMessage, setErrorMessage] = useState('')

    const [startTime, setStartTime] = useState(
        new Date(
            props.startTime.year,
            props.startTime.month - 1,
            props.startTime.day,
            (props.startTime.PM ? props.startTime.hour + 12 : props.startTime.hour),
            props.startTime.minute
        )
    )
    const [endTime, setEndTime] = useState(
        new Date(
            props.endTime.year,
            props.endTime.month - 1,
            props.endTime.day,
            (props.endTime.PM ? props.endTime.hour + 12 : props.endTime.hour),
            props.endTime.minute
        )
    )
    const [timeZone, setTimeZone] = useState(props.timezoneOffset)
    const [imageHeight, setImageHeight] = useState(0)

    const onImgLoad = useCallback(({ target: img }) => {
        setImageHeight(img.offsetHeight)
    }, [setImageHeight])

    const [perItemFee, setPerItemFee] = useState(props.fee.perItemFee)
    const [perOrderFee, setPerOrderFee] = useState(Number((props.fee.perOrderFee * 100).toFixed(2)))
    const [maxItemsPerOrder, setMaxItemsPerOrder] = useState(props.fee.maxItemsPerOrder)
    const [showFloorplan, setShowFloorplan] = useState(props.floorplan ? true : false)
    const [height] = useState(props.floorplan ? props.floorplan.height : 25)
    const [width] = useState(props.floorplan ? props.floorplan.width : 40)
    const [data, setData] = useState([])

    let minX = 3;
    let minY = 3;

    if (props.floorplan) {
        props.floorplan.labels.map((item: any) => {
            if (item.x > minX) {
                minX = item.x
            }
            if (item.y > minY) {
                minY = item.y
            }
        })
        props.floorplan.inventoryMap.map((item: any) => {
            if (item.x > minX) {
                minX = item.x
            }
            if (item.y > minY) {
                minY = item.y
            }
        })
    }

    const [labels] = useState(props.floorplan ? props.floorplan.labels : [])
    const [inventoryMap] = useState(props.floorplan ? props.floorplan.inventoryMap : [])
    const [currNode] = useState({ x: -1, y: -1, label: '' })
    const [collectAddress, setCollectAddress] = useState(props.collectAddress ? props.collectAddress : false)
    const [hideDisplayTime] = useState(props.hideDisplayTime ? props.hideDisplayTime : false)

    const handleStartChange = useCallback((e) => {
        if (e > endTime) {
            setStartTime(e)
            setEndTime(e)
        } else {
            setStartTime(e)
        }
    }, [endTime, setStartTime, setEndTime])

    const handleEndChange = useCallback((e) => {
        if (e < startTime) {
            setStartTime(e)
            setEndTime(e)
        } else {
            setEndTime(e)
        }
    }, [startTime, setStartTime, setEndTime])

    if (startTime.getFullYear() === today.getFullYear()) {
        if (startTime.getMonth() === today.getMonth()) {
            if (startTime.getDate() === today.getDate()) {
                flag1 = true;
            }
        }
    }
    if (endTime.getFullYear() === today.getFullYear()) {
        if (endTime.getMonth() === today.getMonth()) {
            if (endTime.getDate() === today.getDate()) {
                flag2 = true;
            }
        }
    }

    const handleUpdateCampaign = useCallback((imgUrl?: string) => {

        if (name.toString().trim() === '') {
            alert('Name is required')
            return
        }

        if (subdomain === '') {
            alert('Link name is required')
            return
        }

        if (/^[a-zA-Z0-9- ]*$/.test(subdomain) === false) {
            alert('Subdomain should not contain special characters')
            return
        }

        if (collectAddress && surveyQuestion.trim() === '') {
            alert('Survey Question is required')
            return
        }

        if (maxItemsPerOrder <= 0) {
            alert('Max order quantity is at least 1')
            return
        }

        const campaign = {
            name,
            description,
            startTime: {
                year: startTime.getFullYear(),
                month: startTime.getMonth() + 1,
                day: startTime.getDate(),
                hour: startTime.getHours() > 12 ? startTime.getHours() - 12 : startTime.getHours(),
                minute: startTime.getMinutes(),
                PM: startTime.getHours() > 12 ? true : false,
            },
            endTime: {
                year: endTime.getFullYear(),
                month: endTime.getMonth() + 1,
                day: endTime.getDate(),
                hour: endTime.getHours() > 12 ? endTime.getHours() - 12 : endTime.getHours(),
                minute: endTime.getMinutes(),
                PM: endTime.getHours() > 12 ? true : false,
            },
            timezoneOffset: Number(timeZone),
            subdomain: subdomain.toLowerCase(),
            showLeaderboard,
            fee: {
                perItemFee,
                perOrderFee: Number.isNaN(Number(perOrderFee)) ? 0.035 : Number((perOrderFee / 100).toFixed(4)),
                maxItemsPerOrder: Number.isNaN(Number(maxItemsPerOrder)) ? 10 : Number(maxItemsPerOrder)
            },
            media: {
                cover: imgUrl ? imgUrl : cover,
                logo: fpBackground && showFloorplan ? fpBackground : null
            },
            maxLevels: allowAffiliates ? null : 1,
            floorplan: showFloorplan ? { height, width, labels } : null,
            collectAddress,
            surveyQuestion,
            hideDisplayTime,
            location: location ? JSON.stringify(location) : null,
            secretLocation: location ? secretLocation : null
        }

        setBtnDisabled(true)
        setSaveBtnText('SAVING...')

        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: isSubdomainAvailable,
                variables: {
                    subdomain: subdomain.toLowerCase()
                }
            })
            .then(res => {
                if (res.data.data.campaign.isSubdomainAvailable || (subdomain.toLowerCase().toString() === props.subdomain.toString())) {
                    fetchAPI
                        .post(API_ENDPOINTS.BASE_URL, {
                            query: updateCampaign,
                            variables: {
                                campaign,
                                campaignId
                            }
                        })
                        .then(res1 => {
                            if (res1.data.data.campaign.update) {
                                props.reloadData()
                                closeModal()
                            } else {
                                alert('Something went wrong, try again')
                                setBtnDisabled(false)
                                setSaveBtnText('SAVE')
                                return
                            }
                        })
                        .catch(err => {
                            alert('Something went wrong, try again')
                            setBtnDisabled(false)
                            setSaveBtnText('SAVE')
                            return
                        })
                } else {
                    alert('Subdomain already in use, please try another one')
                    setBtnDisabled(false)
                    setSaveBtnText('SAVE')
                    return
                }
            })
            .catch(err => {
                alert('Subdomain already in use, please try another one')
                setBtnDisabled(false)
                setSaveBtnText('SAVE')
                return
            })
    }, [name, description, location, secretLocation, hideDisplayTime, showLeaderboard,
        startTime, endTime, timeZone, props, fpBackground, showFloorplan, collectAddress,
        subdomain, height, width, labels, showFloorplan, surveyQuestion,
        campaignId, maxItemsPerOrder, perOrderFee, perItemFee, cover, allowAffiliates])

    const CustomNode = useCallback(({
        node,
        x,
        y,
        size,
        color,
        blendMode,
        onMouseEnter,
        onMouseMove,
        onMouseLeave,
        onClick,
    }) => {
        const label = labels ? labels.find((i: any) => {
            return i.label.toString().trim() === node.data.serieId.toString().trim()
        }) : null

        let selected = false;
        if (currNode.x === node.data.x && currNode.y === node.data.y) {
            selected = true;
        }

        if (!label) {
            return (
                <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                    <circle
                        stroke={node.data.serieId === 'Available' ? "#242d51" : '#f1f1f1'}
                        stroke-width="0.5"
                        fill-opacity={selected ? 1 : 0.4}
                        stroke-opacity={0.75}
                        r={size * 0.5}
                        fill={selected ? '#d63191' :
                            node.data.serieId === 'Available' ? '#f1f1f1' : '#242d51'}
                        style={{ mixBlendMode: blendMode, zIndex: 15000000, opacity: 1 }}
                        onMouseEnter={onMouseEnter}
                        onMouseMove={onMouseMove}
                        onMouseLeave={onMouseLeave}
                        onClick={onClick}
                    />
                </g>
            )
        }
        return (
            <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                <text
                    x={size * -1}
                    y={size * 0.5}
                    font-size='8px'
                    font-style='bold'
                    color='#1931b9'
                    font-color='#1931b9'
                    style={{ zIndex: 150, opacity: 1 }}
                >
                    {label.label.toUpperCase()}
                </text>
            </g>
        )
    }, [labels, currNode])

    useEffect(() => {
        const initData: any = [];
        initData.push({
            id: 'Available',
            data: []
        })
        for (let x = 0; x < width; x++) {
            for (let y = 0; y < height; y++) {
                const node1 = labels.find((item: any) => {
                    return item.x === x && item.y === y
                })
                const node2 = inventoryMap.find((item: any) => {
                    return item.x === x && item.y === y
                })
                if (node1 === undefined && node2 === undefined) {
                    initData[0].data.push({
                        x, y
                    })
                }
            }
        }
        labels.map((item: any) => {
            initData.push({
                id: item.label,
                data: [{ x: item.x, y: item.y }]
            })
        })

        const allocatedInventory: any[] = [];
        inventoryMap.map((item: any) => {
            allocatedInventory.push({ x: item.x, y: item.y })
        })
        initData.push({
            id: 'Unavailable',
            data: allocatedInventory
        })

        setData(initData)
    }, [height, width, setData, labels, currNode, inventoryMap])

    return <div key={cover}>
        <ImageUpload
            imgSrc={cover !== null ? cover : 'https://platform.isotopeticketing.com/landing.png'}
            onUpload={imgUrl => handleUpdateCampaign(imgUrl)}
        />
        <div style={{ padding: '20px' }}>
            <Text
                label='Name'
                value={name}
                onChange={e => setName(e.target.value)}
                required={true}
            />
            <div style={{ paddingBottom: 15, marginTop: 4, marginBottom: 4 }}>
                <Label>
                    Location (Optional)
                </Label>
                <div style={{ flexDirection: 'row', display: 'flex' }}>
                    <div style={{ width: '90%' }}>
                        <GooglePlacesAutocomplete
                            selectProps={{
                                value: location,
                                onChange: setLocation,
                            }}
                            apiKey="AIzaSyCrggUEQEDx7yKV8XA5MmtS75eDwbnbRY8"
                        />
                    </div>
                    <div style={{ width: '10%', display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'right' }}>
                        {
                            location ?
                                <span onClick={() => setLocation(null)}>
                                    <CloseCircleOutline />
                                </span> : null
                        }
                    </div>
                </div>
                <div style={{ width: '100%', textAlign: 'left', paddingTop: 15 }}>
                    <span style={{ paddingLeft: '20px' }}>
                        <Input
                            disabled={!location}
                            type="checkbox"
                            checked={secretLocation}
                            onChange={e => setSecretLocation(!secretLocation)}
                            style={{ height: 'auto' }}
                        />
                    </span>
                    <span style={{ paddingLeft: '5px' }}>
                        Secret Location
                    </span>
                    <Info>
                        Address will only be shared with your customers.
                    </Info>
                </div>
            </div>
            <TextArea
                label='Description'
                value={description}
                onChange={e => setDescription(e.target.value)}
                required={true}
                placeholder='(Optional)'
            />
            <div style={{ marginTop: 4 }}>
                <Text
                    label='Link Name'
                    value={subdomain}
                    onChange={e => setSubdomain((e.target.value.split(' ').join('')))}
                />
            </div>
            <Info>
                If you enter 'abc' for example, your selling link will be abc.isotopeticketing.com
            </Info>
            {/* <div style={{ paddingLeft: '20px', width: '100%', textAlign: 'left' }}>
                <br />
                <Input
                    type="checkbox"
                    checked={showLeaderboard}
                    onChange={e => setShowLeaderboard(!showLeaderboard)}
                    style={{ height: 'auto' }}
                />
                <span style={{ paddingLeft: '5px' }}>
                    Show Leaderboard to Affiliates
                </span>
            </div> */}
            {/* <div style={{ paddingLeft: '20px', width: '100%', textAlign: 'left' }}>
                <br />
                <Input
                    type="checkbox"
                    checked={allowAffiliates}
                    onChange={e => setAllowAffiliates(!allowAffiliates)}
                    style={{ height: 'auto' }}
                />
                <span style={{ paddingLeft: '5px' }}>
                    Enable Sub-Affiliate Sales
                </span>
            </div> */}
            <div style={{ width: '100%', textAlign: 'left' }}>
                <br />
                <span style={{ paddingLeft: '20px' }}>
                    <Input
                        type="checkbox"
                        checked={collectAddress}
                        onChange={e => setCollectAddress(!collectAddress)}
                        style={{ height: 'auto' }}
                    />
                </span>
                <span style={{ paddingLeft: '5px' }}>
                    Collect Additional Information (Optional)
                </span>
                <Info>
                    By default, a customer's name, e-mail & phone number is collected.
                </Info>
            </div>
            {
                collectAddress ?
                    <Text
                        value={surveyQuestion}
                        onChange={e => setSurveyQuestion(e.target.value)}
                        placeholder={'ex. Shipping Address'}
                    /> : null
            }
            <div style={{ width: '100%', textAlign: 'left' }}>
                <br />
                <span style={{ paddingLeft: '20px' }}>
                    <Input
                        type="checkbox"
                        checked={showFloorplan}
                        onChange={e => setShowFloorplan(!showFloorplan)}
                        style={{ height: 'auto' }}
                        disabled={props.floorplan && props.floorplan.inventoryMap.length > 0 ? true : false}
                    />
                </span>
                <span style={{ paddingLeft: '5px' }}>
                    Seating Layout
                </span>
                <Info>
                    Map tables and sections to your own uploaded image. Create new ticket in 'Links & Tickets' to map tables.
                </Info>
            </div>
            {
                showFloorplan ?
                    <div style={{ paddingBottom: '20px' }}>
                        <ImageUpload
                            imgSrc={fpBackground !== null ? fpBackground : 'https://platform.isotopeticketing.com/landing.png'}
                            onUpload={imgUrl => setFpBackground(imgUrl)}
                            background={true}
                        />
                        <div style={{ position: 'relative', marginTop: '10px' }}>
                            <div style={{ position: 'absolute', width: '100%', textAlign: 'center' }}>
                                {
                                    fpBackground ?
                                        <img src={fpBackground} style={{
                                            width: '100%', opacity: 0.75, zIndex: 30, borderRadius: '10px'
                                        }}
                                            onLoad={e => onImgLoad(e)}
                                        /> : null
                                }
                            </div>
                            <div style={{ position: 'absolute', height: fpBackground ? imageHeight : height * 25, width: '100%', opacity: 1, zIndex: 35 }}>
                                <ResponsiveScatterPlot
                                    data={data}
                                    margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                                    enableGridX={false}
                                    enableGridY={false}
                                    // blendMode="darken"
                                    axisTop={null}
                                    axisRight={null}
                                    axisLeft={null}
                                    axisBottom={null}
                                    onClick={(n, e) => undefined}
                                    colors={{ scheme: 'paired' }}
                                    renderNode={CustomNode}
                                    tooltip={({ node }: any) => (
                                        <div
                                            className='blur-safari'
                                            style={{
                                                padding: '10px',
                                                color: '#242d51',
                                                borderRadius: '15px',
                                                backdropFilter: 'blur(20px)',
                                                border: '0.4px solid #f1f1f1',
                                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.02), 0 1px 3px rgba(0, 0, 0, 0.02)'
                                            }}
                                        >
                                            <strong>
                                                {node.data.serieId}
                                            </strong>
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    : null
            }
            <br />
            <div style={{
                marginTop: showFloorplan ? (
                    fpBackground ? imageHeight + 25 : height * 26
                ) : '0px', paddingBottom: '20px', zIndex: 30
            }}>
                <TimezoneSelect
                    onChange={e => setTimeZone(e.target.value)}
                    value={timeZone}
                    label="Time Zone"
                />
            </div>
            <div style={{ width: '100%', textAlign: 'left' }}>
                {/* <span style={{ paddingLeft: '20px' }}>
                    <Input
                        type="checkbox"
                        checked={!hideDisplayTime}
                        onChange={e => setHideDisplayTime(!hideDisplayTime)}
                        style={{ height: 'auto' }}
                    />
                </span> */}
                <span style={{ paddingLeft: '0px' }}>
                    Event Starts At
                </span>
            </div>
            <div style={{ textAlign: 'left', paddingBottom: '20px' }}>
                {
                    // hideDisplayTime ? null :
                    <div style={{ width: '100%' }}>
                        <br />
                        <DatePicker
                            selected={startTime}
                            onChange={handleStartChange}
                            selectsStart={true}
                            startDate={startTime}
                            endDate={endTime}
                            minDate={new Date()}
                            minTime={flag1 ? new Date() : zero}
                            maxTime={now}

                            showTimeSelect={true}
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="MMMM d, yyyy h:mm aa"
                            timeCaption="time"
                            style={{ width: '100%', border: 'none', backgroundColor: '#ebecf1' }}

                        />
                    </div>
                }
                <p style={{ marginBottom: 20 }} />
                <div style={{ width: '100%' }}>
                    <p style={{ color: '#242d51' }}>Sales End At</p>
                    <DatePicker
                        selected={endTime}
                        onChange={handleEndChange}
                        selectsEnd={true}
                        startDate={startTime}
                        endDate={endTime}
                        minDate={startTime}
                        minTime={flag2 ? new Date() : zero}
                        maxTime={now}
                        showTimeSelect={true}
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        dateFormat="MMMM d, yyyy h:mm aa"
                        timeCaption="time"
                        style={{ width: '100%', border: 'none', backgroundColor: '#ebecf1' }}
                    />
                </div>
                <Info>
                    Payouts are issued 3 business days once sales end.
                </Info>
            </div>
            <NumberInput
                label='Max Tickets Per Order'
                value={maxItemsPerOrder}
                onChange={e => setMaxItemsPerOrder(e.target.value)}
                required={true}
            />
            {
                props.user.isAdmin ?
                    <div>
                        <h6 style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                            Admin Controls
                        </h6>
                        <NumberInput
                            label='Per Item Fee $'
                            value={Number((perItemFee / 100).toFixed(2))}
                            onChange={e => setPerItemFee(Number((e.target.value * 100).toFixed(2)))}
                            required={true}
                        />
                        <NumberInput
                            label='Per Order Fee %'
                            value={perOrderFee}
                            onChange={e => setPerOrderFee(e.target.value)}
                            required={true}
                        />
                    </div> : null
            }
            {/* {
                error ?
                    <div style={{ padding: '20px' }}>
                        <Error content={errorMessage} />
                    </div>
                    : null
            } */}
            <div style={{ width: '100%', textAlign: 'center', paddingTop: '20px' }}>
                <button
                    disabled={btnDisabled}
                    role="submit"
                    type="submit"
                    className="new-button-save"
                    onClick={e => handleUpdateCampaign()}
                >
                    {saveBtnText}
                </button>
            </div>
            <div style={{ width: '100%', textAlign: 'center', paddingTop: '10px' }}>
                <button className='new-button-cancel' onClick={() => closeModal()}>
                    CANCEL
                </button>
            </div>
        </div>
    </div>
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(CampaignSettingsModal);


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsDashboard/CampaignSettings.tsx